import {redactValue} from '../sensitiveFieldKeys';

/**
 * Redacts sensitive values from a RUM event's context. Called once per event, from
 * `beforeSend` in `datadogRum.ts` — the single point where per-call context (actions,
 * vitals, errors) and view/global context have all been merged into `event.context`.
 *
 * Values under SENSITIVE_KEYS are replaced with REDACTED at any nesting depth, in
 * every environment: telemetry must never leak secrets. Context *key* conventions are
 * not enforced here — that happens statically at lint time (the
 * `wandb/dd-event-context-keys` rule and the registry guard tests), so it can never
 * interfere with production behavior.
 *
 * Returns the original reference when nothing was redacted.
 */
export function redactRumContext<T extends object>(context: T): T;
export function redactRumContext<T extends object>(
  context: T | undefined
): T | undefined;
export function redactRumContext<T extends object>(
  context: T | undefined
): T | undefined {
  if (context == null) {
    return context;
  }
  const {value, changed} = redactValue(context);
  return changed ? (value as T) : context;
}
